/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const loan = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.25 13h-1M.75 13h1m0 0V3.467c0-.258.209-.467.467-.467h1.566c.258 0 .467.209.467.467V13m-2.5 0h2.5m0 0h2.5m0 0V5.967c0-.258.209-.467.467-.467l1.533-.011c.258 0 .467.209.467.467V13M6.75 13h2.467m0 0h2.533m0 0V8.444c0-.257.209-.466.467-.466h1.566c.258 0 .467.209.467.466V13m-2.5 0h2.5"
    />
  </svg>
)
export default loan
